import sanitizeHtml from "sanitize-html";

const RICH_TEXT_OPTIONS: sanitizeHtml.IOptions = {
  allowedTags: [
    "br",
    "p",
    "b",
    "strong",
    "i",
    "em",
    "u",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
  ],
  allowedAttributes: {},
  // Drop any unexpected markup; keep text content.
  disallowedTagsMode: "discard",
};

const BLOCK_TAG_RE = /<\/?(?:p|h[1-6])\b/i;

/** Sanitize limited HTML; plain newlines become line breaks when no block tags. */
export function toSafeRichHtml(input: string): string {
  const prepared = BLOCK_TAG_RE.test(input)
    ? input
    : input.replace(/\r\n|\r|\n/g, "<br>");
  return sanitizeHtml(prepared, RICH_TEXT_OPTIONS);
}

/** Plain text for cards / previews (no markup). */
export function stripRichText(input: string): string {
  return sanitizeHtml(input, {
    allowedTags: [],
    allowedAttributes: {},
  })
    .replace(/\s+/g, " ")
    .trim();
}
